module.exports = __webpack_public_path__ + "static/media/down_chevron_primary.f252d775.svg";